import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "genericPadding hasHeader bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "fs_12 greyBlue" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_6 = { class: "form-group squareInputContainer withLabel w-100 me-1" }
const _hoisted_7 = { class: "form-group squareInputContainer withLabel mt-3" }
const _hoisted_8 = { class: "d-flex flex-wrap" }
const _hoisted_9 = { class: "footerButtonContainer" }
const _hoisted_10 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode("span", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.local.tag.identifier != _ctx.emptyGuid ? "Modifica" : "Nuovo") + " ", 1),
        _createVNode(_component_localized_text, {
          localizedKey: 'app_topic',
          text: 'Topic'
        })
      ]),
      _hoisted_5
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_nometopic",
          text: "Nome topic",
          class: "fs_12 grey"
        })
      ]),
      _withDirectives(_createVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.local.tag.tag = $event)),
        class: "genericInput squareInput"
      }, null, 512), [
        [_vModelText, _ctx.local.tag.tag]
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_scriviunadescrizione",
          text: "Scrivi una descrizione",
          class: "fs_12 grey"
        })
      ]),
      _withDirectives(_createVNode("textarea", {
        class: "genericInput squareInput ptInput",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.local.tag.description = $event))
      }, null, 512), [
        [_vModelText, _ctx.local.tag.description]
      ])
    ]),
    _createVNode(_component_localized_text, {
      class: "fs_12 greyBlue d-block mt-2 mb-2",
      localizedKey: "app_stato",
      text: "Stato"
    }),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", {
        class: ["filterTab", _ctx.local.published ? 'active' : ''],
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.local.published = true))
      }, [
        _createVNode(_component_localized_text, {
          class: "fs_12 d-block",
          localizedKey: "app_pubblicato",
          text: "Pubblicato"
        })
      ], 2),
      _createVNode("div", {
        class: ["filterTab", !_ctx.local.published ? 'active' : ''],
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.local.published = false))
      }, [
        _createVNode(_component_localized_text, {
          class: "fs_12 d-block",
          localizedKey: "app_nonpubblicato",
          text: "Non pubblicato"
        })
      ], 2)
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        (_ctx.local.tag.identifier != _ctx.emptyGuid)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              type: "button",
              class: "genericButton bgRed squareGenericButton w-100 me-1",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteTopic()))
            }, [
              _createVNode(_component_localized_text, {
                class: "fs_14 white",
                localizedKey: "app_eliminaTopic",
                text: "Elimina Topic"
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode("button", {
          type: "button",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save())),
          disabled: _ctx.disabled,
          class: ["genericButton bgGreyBlue w-100", _ctx.local.tag.identifier != _ctx.emptyGuid ? 'ms-1' : '']
        }, [
          _createVNode(_component_localized_text, {
            class: "fs_14 white",
            localizedKey: "app_salvaTopic",
            text: "Salva Topic"
          })
        ], 10, ["disabled"])
      ])
    ])
  ]))
}